import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/Home/index.vue";
import solution from "@/views/solution/index.vue";
import productService from "@/views/productService/index.vue";
import coreTechnology from "@/views/coreTechnology/index.vue";
import zoology from "@/views/zoology/index.vue";
import about from "@/views/about/index.vue";
import dataApi from "@/views/dataApi/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/dataApi/:menuid?/:menuitemid?",
  //   name: "dataApi",
  //   component: dataApi,
  // },
  {
    // 关于我们
    path: "/about",
    name: "about",
    component: about,
    children: [
      {
        // 公司介绍
        path: "company",
        name: "company",
        component: () => import("@/views/about/page/company.vue"),
      },
      {
        // 新闻资讯
        path: "news",
        name: "news",
        component: () => import("@/views/about/page/news.vue"),
      },
      {
        // 联系我们
        path: "contactUs",
        name: "contactUs",
        component: () => import("@/views/about/page/contactUs.vue"),
      },
      {
        // 招贤纳士
        path: "recruit",
        name: "recruit",
        component: () => import("@/views/about/page/recruit.vue"),
      },
    ],
  },
  {
    // 核心技术
    path: "/coreTechnology",
    name: "coreTechnology",
    component: coreTechnology,
    children: [
      {
        // 核心算法
        path: "deepLearning",
        name: "deepLearning",
        component: () => import("@/views/coreTechnology/page/deepLearning.vue"),
      },
      {
        // 气象AI数据服务平台
        path: "weatherAI",
        name: "weatherAI",
        component: () => import("@/views/coreTechnology/page/weatherAI.vue"),
      },
    ],
  },
  {
    // 生态合作
    path: "/zoology",
    name: "zoology",
    component: zoology,
    children: [
      {
        // 合作伙伴
        path: "cooperation",
        name: "cooperation",
        component: () => import("@/views/zoology/page/cooperation.vue"),
      },
      {
        // 生态合伙人
        path: "partner",
        name: "partner",
        component: () => import("@/views/zoology/page/partner.vue"),
      },
      {
        // 生态合伙人
        path: "join",
        name: "join",
        component: () => import("@/views/zoology/page/join.vue"),
      },
    ],
  },
  {
    // 解决方案
    path: "/solution",
    name: "solution",
    component: solution,
    children: [
      {
        // 农业气象服务
        path: "geoponics",
        name: "geoponics",
        component: () => import("@/views/solution/page/geoponics.vue"),
      },
      {
        // 保险气象服务
        path: "insurance",
        name: "insurance",
        component: () => import("@/views/solution/page/insurance.vue"),
      },
      {
        // 旅游气象服务
        path: "tour",
        name: "tour",
        component: () => import("@/views/solution/page/tour.vue"),
      },
      {
        // 航空气象服务
        path: "aviation",
        name: "aviation",
        component: () => import("@/views/solution/page/aviation.vue"),
      },
      {
        // 交通气象服务
        path: "traffic",
        name: "traffic",
        component: () => import("@/views/solution/page/traffic.vue"),
      },
      {
        // 体育赛事气象服务
        path: "sports",
        name: "sports",
        component: () => import("@/views/solution/page/sports.vue"),
      },
      {
        //危化品气象服务
        path: "extreme",
        name: "extreme",
        component: () => import("@/views/solution/page/extreme.vue"),
      },
      {
        //新能源气象服务
        path: "energy",
        name: "energy",
        component: () => import("@/views/solution/page/energy.vue"),
      },
    ],
  },
  {
    // 产品服务
    path: "/productService",
    name: "productService",
    component: productService,
    children: [
      {
        // 气象可视化
        path: "weatherVisual",
        name: "weatherVisual",
        component: () =>
          import("@/views/productService/page/weatherVisual.vue"),
      },
      {
        // 气象预报预警平台
        path: "integrationPlatform",
        name: "integrationPlatform",
        component: () =>
          import("@/views/productService/page/integrationPlatform.vue"),
      },
      {
        // 水电站监管平台
        path: "waterConservancy",
        name: "waterConservancy",
        component: () =>
          import("@/views/productService/page/waterConservancy.vue"),
      },
      {
        // AIoT智能观测台
        path: "AIoT",
        name: "AIoT",
        component: () => import("@/views/productService/page/AIoT.vue"),
      },
      {
        // McTriqger机器人
        path: "robot",
        name: "robot",
        component: () => import("@/views/productService/page/robot.vue"),
      },
      {
        // HISTORY气象台
        path: "history",
        name: "history",
        component: () => import("@/views/productService/page/history.vue"),
      },
    ],
  },
  {
    // 数据产品
    path: "/dataProduct/:menuid?/:menuitemid?",
    name: "dataProduct",
    component: dataApi,
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL)
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
